import ReactDOM from 'react-dom/client'

import { parseInitData } from '../shared/utils'
import Share, { NewContentItem } from './Share'

const rootEl = document.getElementById('news-content-react-root')
const dataEl = document.getElementById('news-content-init-data')

if (rootEl && dataEl) {
  try {
    const initData = parseInitData<NewContentItem>('news-content-init-data')
    const root = ReactDOM.createRoot(rootEl)
    root.render(<Share newsUrl={initData?.newsUrl} />)
  } catch {}
}
